<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @open-detail="openDetail"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <Detail
      :visible.sync="detailOpts.visible"
      :reportTaskRecordCode="detailOpts.reportTaskRecordCode"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import Detail from '../detail'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Detail },
  data() {
    return {
      usePage: true,
      detailOpts: { visible: false, reportTaskRecordCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzApiReportTaskRecordListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetail({ reportTaskRecordCode }) {
      this.detailOpts = { visible: true, reportTaskRecordCode }
    },
  },
}
</script>
